import __var_0__ from '@stdlib/vendor/debug.js';
import __var_1__ from '@stdlib/assert/is-finite';
import __var_2__ from '@stdlib/assert/is-null';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var logger = __var_0__;
var isFiniteNumber = __var_1__.isPrimitive;
var isNull = __var_2__;


// VARIABLES //

var debug = logger( 'sparkline:column-chart:unicode:set:y-min' );


// MAIN //

/**
* Sets the minimum value of the y-axis domain.
*
* @private
* @param {(FiniteNumber|null)} min - minimum value
* @throws {TypeError} must be a finite number primitive or null
*/
function set( min ) {
	/* eslint-disable no-invalid-this */
	if ( !isFiniteNumber( min ) && !isNull( min ) ) {
		throw new TypeError( 'invalid value. `yMin` must be a finite number primitive or null. Value: `' + min + '`.' );
	}
	if ( min !== this._yMin ) {
		debug( 'Current value: %s.', this._yMin );

		this._yMin = min;
		debug( 'New value: %s.', this._yMin );

		this.emit( 'change' );
	}
}


// EXPORTS //
export default set;
